import { gameWinModalContent } from '../constants/copyright'
import { taskCompleteModalContent } from '../constants/copyright-modals'
import { useModal } from './useModal'
import { useRequestsHandlerData } from './useRequestsHandlerData'
import useGetLootboxType from './shared/lootboxes/useGetLootboxType'
import { PREMIUM, STANDARD, useAccountMode } from './useAccountMode'
import { useApplicationCallbacks } from '../providers/application-callbacks'
import { useGoldenAppleUrl } from './useGoldenAppleUrl'

export const useGetPrizeFromQuest = () => {
  const { addModal } = useModal()
  const { mode: accountMode } = useAccountMode()
  const getLootboxType = useGetLootboxType()
  const callbacks = useApplicationCallbacks()
  const goldenAppleUrl = useGoldenAppleUrl()

  return useRequestsHandlerData([
    { address: 'requestsGameCompleteQuest' },
    {
      address: 'requestsGameCollectQuest',
      fulfilled(data) {
        const questType = getQuestType(data)

        const handlers = {
          promocode() {
            const {
              userPrize: { title, image, description, promocode, link, money, attempts } = {},
            } = data?.quest ?? {}
            addModal({
              type: 'winModal',
              props: {
                ...gameWinModalContent,
                title,
                reward: attempts,
                price: money,
                promocode,
                description,
                linkBtn: link || goldenAppleUrl,
                callbacks,
                promocodeImg: image,
              },
            })
          },
          clothes() {
            const { userPrize } = data?.quest ?? {}

            const allClothes = Object.entries(userPrize ?? {}).reduce((acc, [key, value]) => {
              if (key.startsWith('shopItem') && !!value) acc.push(value.preview_image)
              return acc
            }, [])

            addModal({
              type: 'taskCompleteModal',
              props: { ...taskCompleteModalContent, clothes: allClothes },
            })
          },
          default() {
            const { quest: { userPrize, prize, premiumPrize } = {} } = data ?? {}
            const totalPrize =
              userPrize ?? { [PREMIUM]: premiumPrize, [STANDARD]: prize }[accountMode] ?? prize
            const {
              attempts,
              gacha_event_cash,
              money,
              type,
              gachaItem,
              gacha_item_count,
              gacha_item_id,
              score,
              beauties,
              reward_bonuses,
              image,
            } = totalPrize ?? {}

            addModal({
              type: 'taskCompleteModal',
              props: {
                ...taskCompleteModalContent,
                attempts,
                premiumPrize,
                charms: gacha_event_cash,
                price: money,
                gachaItem,
                gacha_item_count,
                gachaItemType: getLootboxType(gacha_item_id ?? gachaItem?.id),
                gachaItemQuantity: gachaItem?.bought,
                prizeImage: image ?? gachaItem?.image,
                ticket: Number(type === 'Ticket'),
                beauties,
                score: reward_bonuses ? null : score,
                rewardBonuses: reward_bonuses,
              },
            })
          },
        }

        handlers[questType]?.()
      },
    },
  ])
}

function getQuestType(data) {
  const { userPrize } = data?.quest ?? {}

  const logicData = [
    {
      condition() {
        return Boolean(userPrize?.promocode)
      },
      key: 'promocode',
    },
    {
      condition() {
        return Object.entries(userPrize ?? {}).some(
          ([key, value]) => key.startsWith('shopItem') && !!value,
        )
      },
      key: 'clothes',
    },
  ]

  for (const { condition, key } of logicData) if (condition()) return key
  return 'default'
}
